module.exports = __webpack_public_path__ + "img/diaohua7.b7bccd3b.jpg";